import { useNuxtApp } from '#imports';
import type { ReportClientError } from '~/plugins/error-reporter.client';
import { createLogger } from '~/utils/logger';

const logger = createLogger('error-reporter');

export const useErrorReporter = (): ReportClientError => {
    const { $reportClientError } = useNuxtApp();
    return (
        $reportClientError ??
        ((error, context) =>
            logger.error('Unhandled client error', { event: 'application_error', ...context }, error))
    );
};
